import { subscribeToFlows, type FlowWithId } from '@/services/flows-service';

import { useFirestoreSubscription } from './use-firestore-subscription';

export const useFlows = () => {
  const { data, isLoading, error } = useFirestoreSubscription<FlowWithId>(subscribeToFlows, []);

  return {
    flows: data,
    isLoading,
    error,
  };
};
